import { render, staticRenderFns } from "./-oz-rich-desktop-modal.vue?vue&type=template&id=a00b2308&scoped=true&"
import script from "./-oz-rich-desktop-modal.vue?vue&type=script&lang=ts&"
export * from "./-oz-rich-desktop-modal.vue?vue&type=script&lang=ts&"
import style0 from "./-oz-rich-desktop-modal.vue?vue&type=style&index=0&id=a00b2308&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00b2308",
  null
  
)

export default component.exports